import Axios, { AxiosRequestConfig } from 'axios';
import {
  BASIC_USERNAME,
  BASIC_PASSWORD,
  URL_BACKEND_ROOT
} from "../app/AppConst";

export interface Credentials {
  username: string;
  password: string;
  grant_type: string;
}

export const onLogin = async (data: Credentials) => {
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Authorization': `Basic ${window.btoa(`${BASIC_USERNAME}:${BASIC_PASSWORD}`)}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/uaa/oauth/token',
    data
  }

  try {
    const {data: response} = await Axios.request(requestConfig);
    console.log(response);
    return response;
  } catch (e: any) {
    console.log(e);
    return {error: e.response.data.error_description}
  }
}

export const onLogout = async () => {
  localStorage.removeItem('accessToken');
  return 0;
}

export interface menuGroup {
  id: number | undefined;
  groupName: string;
}